<template>
    <div>
      <div class="d-flex">
          <b-form-checkbox class="mr-3" v-model="filters.sortByAchievements">
              Сначала ученики с наибольшим количеством достижений
          </b-form-checkbox>
          <b-form-checkbox v-model="filters.onlyMarked">
              Ученики, добавленные в избранное
          </b-form-checkbox>
      </div>
      <b-form-group label="Город">
        <MultiSelect
          :value="filters.cities"
          :multiple="true"
          :options="cities"
          @input="onSelectCity"
        />
      </b-form-group>
      <b-form-group label="Учебное заведение">
        <MultiSelect
          :value="filters.studyOrganizations"
          :multiple="true"
          :options="studyOrganizations"
          @input="onSelectStudyOrg"
        />
      </b-form-group>
      <b-form-group label="Текущий класс">
        <MultiSelect
          :value="filters.classes"
          :multiple="true"
          :options="classes"
          @input="onSelectClasses"
        />
      </b-form-group>
      <b-form-group label="Заинтересовавшие ДО">
        <MultiSelect
          :value="filters.interestedDo"
          :multiple="true"
          :options="interestedDo"
          label="title"
          trackBy="id"
          @input="onSelectInterestedDo"
        />
      </b-form-group>
      <b-form-group label="Заинтересовавшие профессии">
        <MultiSelect
          :value="filters.interestedProfessions"
          :multiple="true"
          :options="interestedProfessions"
          label="title"
          trackBy="id"
          @input="onSelectProfession"
        />
      </b-form-group>
      <b-form-group label="Пол">
        <RawMultiselect 
        v-model="filters.gender" 
        :options="GENDERS" 
        label="text" 
        trackBy="value"
        placeholder="Выберите вариант"
        selectLabel="Нажмите enter, чтобы выбрать"
        deselectLabel="Нажмите enter, чтобы удалить">
        </RawMultiselect>
      </b-form-group>
      <b-form-group label="Гражданство">
        <RawMultiselect 
          v-model="filters.citizenship" 
          :options="citizenships" 
          label="text" 
          trackBy="value" 
          placeholder="Выберите вариант"
          selectLabel="Нажмите enter, чтобы выбрать"
          deselectLabel="Нажмите enter, чтобы удалить">
        </RawMultiselect>
      </b-form-group>
    </div>
  </template>
  
  <script>
  import _ from 'lodash'
  import MultiSelect from '@/components/ui/MultiSelect.vue'
  import ExamFilterModal from '@/components/common/university/ExamFilterModal.vue'
  import RawMultiselect from 'vue-multiselect'
  
  export default {
    name: 'ProfessionInterestedFilter',
    components: {
      MultiSelect,
      ExamFilterModal,
      RawMultiselect
    },
    props: {
      cities: {
        type: Array,
        default() {
          return []
        }
      },
      interestedDo: {
        type: Array,
        default() {
            return [];
        }
      },
      interestedProfessions: {
        type: Array,
        default() {
            return [];
        }
      },
      studyOrganizations: {
        type: Array,
        default() {
            return [];
        }
      },
      classes: {
        type: Array,
        default() {
            return [];
        }
      },
      interestedDoValue: {
        type: Array,
        default() {
          return [];
        }
      },
      interestedProfessionsValue: {
        type: Array,
        default() {
          return []
        }
      },
      citizenships: {
        type: Array,
        default() {
          return []
        }
      }
    },
    data() {
      return {
        filters: {
          cities: [],
          interestedDo: [],
          interestedProfessions: [],
          studyOrganizations: [],
          classes: [],
          onlyMarked: false,
          sortByAchievements: false,
          gender: null,
          citizenship: null
        },
        GENDERS: [
          { value: 'm', text: 'М' },
          { value: 'f', text: 'Ж' },
        ],
        countries: []
      }
    },
    watch: {
      filters: {
        deep: true,
        handler(data) {
          this.$emit('filter', data)
        }
      }
    },
    computed: {
    },
    async created() {
      this.filters.interestedDo = _.cloneDeep(this.interestedDoValue);
      this.filters.interestedProfessions = _.cloneDeep(this.interestedProfessionsValue)
    },
    methods: {
      onSelectCity(obj) {
        this.filters.cities = obj
      },
      onSelectStudyOrg(obj) {
        this.filters.studyOrganizations = obj;
      },
      onSelectClasses(obj) {
        this.filters.classes  = obj;
      },
      onSelectInterestedDo(obj) {
        this.filters.interestedDo = obj;
      },
      onSelectProfession(obj) {
        this.filters.interestedProfessions = obj;
      }
    }
  }
  </script>
  
  <style scoped>
  .multiselect--disabled {
    opacity: 1 !important;
  }
  </style>
  